import { render, staticRenderFns } from "./DossierPeppolEndpointCreateModal.vue?vue&type=template&id=51b6da73&scoped=true&"
import script from "./DossierPeppolEndpointCreateModal.vue?vue&type=script&lang=ts&"
export * from "./DossierPeppolEndpointCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6da73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b6da73')) {
      api.createRecord('51b6da73', component.options)
    } else {
      api.reload('51b6da73', component.options)
    }
    module.hot.accept("./DossierPeppolEndpointCreateModal.vue?vue&type=template&id=51b6da73&scoped=true&", function () {
      api.rerender('51b6da73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierPeppolEndpointCreateModal.vue"
export default component.exports